import { scales } from "chart.js";
import { getLegendPosition } from "../utils/stylesUtils";

const getDataLabels = (option: number, value: any, index: number) => {

    if(!value) return '';

    switch (option) {
        case 3: return value;
        case 9: return (index === 1)  ? Number(value)?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : value;
        case 11: return `Clientes: ${value['value']}` + '\n' + 
                        `Manutenção: ${value['Manutencao']?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}` + '\n' + 
                        `Percentual: ${value['Percentual']}%`;
        default: return value;
    }
}

const scalesDefault = {
    yAxes: [{
        id: 'A',
        type: 'linear',
        position: 'left',
    }],
    x: {
        ticks: {
            font: {
                family: "Arial", 
                size: 11,        
                weight: "bold", 
            },
            color: localStorage.getItem('theme') === 'dark' ? 'white' : 'black'
        }
    }
}

const scalesDouble = {
    yAxes: [{
        id: 'A',
        type: 'linear',
        position: 'left',
    }, {
        id: 'B',
        type: 'linear',
        position: 'right',
        ticks: {
        max: 1,
        min: 0
        }
    }]
}

export const getChartOptionsHorizontal = (option: number, orientation: string, animations: boolean, handleClickRequest: Function) => {

    return {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 5,
        scales: option === 8 || option === 10 || option === 11 || option === 13 ? scalesDefault : scalesDouble,
        indexAxis: 'x',
        parsing: {
            xAxisKey: 'Total',
            yAxisKey: 'Total',
        },
        plugins: {
            legend: {
                value: getLegendPosition(option, orientation),
                display: option != 3 
            },
            datalabels: {
                anchor: 'end',
                align: 'top',
                formatter: (value: any, i: any) => {
                    return getDataLabels(option, value, i.datasetIndex);
                },
                color: 'black',
                font: {
                    size: 14,
                },
            },
        },
        interaction: {
            mode: 'x',
        },
        onClick: (e: Event, i: Array<any>) => {
            if (i.length > 0 && (option === 3 || option === 4 || option === 5 || option === 13)) {
                handleClickRequest(i);
            }
        },
        animations: animations ? {
            tension: {
                duration: 1000,
                easing: 'linear',
                from: 1,
                to: 0,
                loop: true,
            },
        } : {},
        
    };
};

export const optionsVertical = (option: number, orientation: string, animations: boolean, handleClickRequest: Function) => {

    return {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 2,
        indexAxis: 'y',
        plugins: {
            legend: getLegendPosition(option, orientation),
            datalabels: {
                anchor: 'end',
                align: 'top',
                formatter: (value: any, i: any) => {
                    return getDataLabels(option, value, i.datasetIndex);
                },
                color: 'black',
                font: {
                    size: 14,
                },
            },
        },
        interaction: {
            mode:  'y'
        },
        onClick: (e: Event, i: Array<any>) => {
            if( i.length > 0 ){
                handleClickRequest(i)
            }
        },
        animations: (animations) ? {
            tension: {
            duration: 1000,
            easing: 'linear',
            from: 1,
            to: 0,
            loop: true
            }
        } : {},

    };
};        
